// db/default-parse-functions.ts
import { DateTime } from "luxon";
var parseNumber = (defaultValue) => (val) => {
  if (val === void 0 || val === null)
    return defaultValue || null;
  else if (!isNaN(+val))
    return val;
  else
    throw new Error(`number ${val} is defined but cant be parsed`);
};
var parseDate = (val) => {
  if (val) {
    if (val.split(".").length === 3)
      val = val.split(".").map((str, i) => i <= 1 ? ("00" + str).slice(-2) : ("20" + str).slice(-4)).join(".");
    if (val === "31.12.9999" || val === "9999-12-31")
      return null;
    const formatsToTest = ["dd.MM.yyyy", "yyyy-MM-dd"];
    for (const format of formatsToTest) {
      const date = DateTime.fromFormat(val, format);
      if (date.isValid)
        return date;
    }
    throw new Error(`Failed to parse date ${val} with formats ${formatsToTest.map((f) => `"${f}"`).join(", ")}`);
  } else
    return null;
};
var parseDateToBool = (val) => {
  if (!val || val === "31.12.9999")
    return false;
  return true;
};
var parseBoolean = (defaultBool) => {
  return (val) => {
    if (val === void 0 || val === "")
      if (defaultBool !== void 0)
        return defaultBool;
      else
        throw new Error("no bool in field and no default bool given either");
    switch (val.toLocaleLowerCase()) {
      case "ja":
      case "yes":
      case "1":
        return true;
      case "nein":
      case "no":
      case "0":
        return false;
      default:
        throw new Error("cant parse boolean value " + val);
    }
  };
};
export {
  parseBoolean,
  parseDate,
  parseDateToBool,
  parseNumber
};
